"use strict";

exports.__esModule = true;
exports.default = void 0;

var _formRadio = _interopRequireDefault(require("./form-radio"));

var _formRadioGroup = _interopRequireDefault(require("./form-radio-group"));

var _plugins = require("../../utils/plugins");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {
  BFormRadio: _formRadio.default,
  BRadio: _formRadio.default,
  BFormRadioGroup: _formRadioGroup.default,
  BRadioGroup: _formRadioGroup.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/form-radio/index.js
// module id = 375
// module chunks = 0